module.exports = __webpack_public_path__ + "static/media/policy-success.0bee2e55.svg";